import { OutgoingMessageChatMessageKind } from '@engyalo/salesdesk-chat-socket-ts-client';
import { TFunction } from 'i18next';
import { ChatMessageType } from 'components/Messages/Message';

const MEDIA_PREVIEW_I18N_KEYS: Partial<Record<OutgoingMessageChatMessageKind, string>> = {
  [OutgoingMessageChatMessageKind.Image]: 'image',
  [OutgoingMessageChatMessageKind.Video]: 'videoMessage',
  [OutgoingMessageChatMessageKind.Audio]: 'audioMessage',
  [OutgoingMessageChatMessageKind.Document]: 'documentMessage',
};

const MEDIA_PREVIEW_ICONS: Partial<Record<OutgoingMessageChatMessageKind, string>> = {
  [OutgoingMessageChatMessageKind.Image]: '\u{1F4F7}',
  [OutgoingMessageChatMessageKind.Video]: '\u{1F3A5}',
  [OutgoingMessageChatMessageKind.Audio]: '\u{1F3B5}',
  [OutgoingMessageChatMessageKind.Document]: '\u{1F4C4}',
};

export const getMessagePreviewText = (chat: ChatMessageType | undefined, t: TFunction): string => {
  if (!chat) return t('message');

  const { kind } = chat;
  const i18nKey = kind && MEDIA_PREVIEW_I18N_KEYS[kind];
  if (i18nKey) {
    return `${MEDIA_PREVIEW_ICONS[kind as OutgoingMessageChatMessageKind]} ${t(i18nKey)}`;
  }

  return chat.text?.body || t('message');
};
